import { MutableRefObject } from "react";
import { Spinner } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import Button from "components/base/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave } from "@fortawesome/free-solid-svg-icons";
import { useCriarTabelaPreco, useAlterarTabelaPreco } from "hooks/useTabelaPreco";
import { SalvarTabelaPrecoDto, TipoCalculoTabelaPreco } from "services/tabelaPrecoService";
import { TabelaPrecoFormValues } from "pages/retaguarda/tabelaPrecoForm";

interface BotaoSalvarTabelaPrecoProps {
  id?: string;
  bypassBlockerRef?: MutableRefObject<boolean>;
}

const BotaoSalvarTabelaPreco = ({ id, bypassBlockerRef }: BotaoSalvarTabelaPrecoProps) => {
  const navigate = useNavigate();
  const { handleSubmit, reset } = useFormContext<TabelaPrecoFormValues>();

  const criarMutation = useCriarTabelaPreco();
  const alterarMutation = useAlterarTabelaPreco();

  const isPending = criarMutation.isPending || alterarMutation.isPending;

  const onSubmit = (values: TabelaPrecoFormValues) => {
    const dto: SalvarTabelaPrecoDto = {
      nome: values.nome,
      ativa: values.ativa,
      tipoCalculo: values.tipoCalculo as TipoCalculoTabelaPreco,
      percentual: values.tipoCalculo === TipoCalculoTabelaPreco.ValorFixo ? 0 : values.percentual,
      empresasIds: values.empresasIds,
      regrasEspeciais: values.regrasEspeciais.map((r) => ({
        produtoId: r.produtoId,
        tipoCalculo: r.tipoCalculo,
        // ValorFixo na regra = valor R$ digitado; demais tipos = percentual. Sempre envia o valor.
        percentual: r.percentual,
      })),
    };

    // Libera o blocker e limpa o dirty antes de navegar (senão o modal de
    // alterações não salvas dispara ao salvar).
    const irParaLista = () => {
      if (bypassBlockerRef) bypassBlockerRef.current = true;
      reset(values);
      navigate("/cadastros/tabela-preco");
    };

    if (id) {
      alterarMutation.mutate({ id, data: dto }, { onSuccess: irParaLista });
    } else {
      criarMutation.mutate(dto, { onSuccess: irParaLista });
    }
  };

  return (
    <Button
      variant="primary"
      onClick={handleSubmit(onSubmit)}
      disabled={isPending}
    >
      {isPending ? (
        <>
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
            className="me-2"
          />
          Salvando...
        </>
      ) : (
        <>
          <FontAwesomeIcon icon={faSave} className="me-2" />
          Salvar
        </>
      )}
    </Button>
  );
};

export default BotaoSalvarTabelaPreco;
